import {useEffect, useState} from "react";
import {animated, useSpring} from "@react-spring/web";
import styles from "../marketing.module.scss";

const boxHeight = 7.4
const gap = 3.1
const boxWithGap = boxHeight + gap
const centerBoxY = 75 - (boxHeight / 2)
const rects = [
    { range: [1.9, 2.3, 2.39, 3], output: [0, 0, 1, 1] },
    { range: [1.9, 2.28, 2.34, 3], output: [0, 0, 1, 1] },
    { range: [1.9, 2.25, 2.31, 3], output: [0, 0, 1, 1] },
    { range: [1.9, 2.22, 2.28, 3], output: [0, 0, 1, 1] },
    { range: [1.9, 2.18, 2.24, 3], output: [0, 0, 1, 1] },
    { range: [1.9, 2.14, 2.2, 3], output: [0, 0, 1, 1] },
    { range: [1.9, 2.095, 2.155, 3], output: [0, 0, 1, 1] },
    { range: [1.9, 2.05, 2.11, 3], output: [0, 0, 1, 1] },
    { range: [1.9, 2.00, 2.06, 3], output: [0, 0, 1, 1] },
    { range: [1.9, 1.95, 2.01, 3], output: [0, 0, 1, 1] },
    { range: [1.9, 1.901, 1.960, 3], output: [0, 0, 1, 1] },
]
export const Section07 = (props) => {
    const [frame, setFrame] = useState(0)
    const spring = useSpring({ x: frame })

    useEffect(() => {
        if (!props.ranges?.length || props.ranges[0].length < 2) return
        const currentFrame = props.run(props)
        // console.log(currentFrame)
        setFrame(currentFrame)
    }, [props.pageYOffset, props.innerHeight])

    return (
        <animated.div className={`${styles['animation-container']} ${styles['white-like-background']}`} style={{
            opacity: spring.x.to({
                range: props.section.opacityRange as number[],
                output: props.section.opacityOutput as number[]
            }).to(x => x),
        }}>
            <div className={`${styles.sec} ${styles.sec07}`}>
                <animated.p className={`${styles.sec07__font01} ${styles.marginDel}`} style={{
                    opacity: spring.x.to({
                        range: [0, 0.1, 0.3, 2.5, 2.6],
                        output: [0, 0, 1, 1, 0]
                    }).to(x => x),
                    translateY: spring.x.to({
                        range: [0, 0.1, 0.3, 1, 2.4, 2.6],
                        output: [10, 10, 0, 0, 0, -10]
                    }).to(x => `${x}vh`)
                }}>거래할 때마다</animated.p>
                <animated.p className={`${styles.sec07__font02} ${styles.notoBold} ${styles.marginDel}`} style={{
                    opacity: spring.x.to({
                        range: [0, 0.1, 0.3, 2.5, 2.6],
                        output: [0, 0, 1, 1, 0]
                    }).to(x => x),
                    translateY: spring.x.to({
                        range: [0, 0.1, 0.3, 1, 2.4, 2.6],
                        output: [10, 10, 0, 0, 0, -10]
                    }).to(x => `${x}vh`),
                    WebkitTextFillColor: spring.x.to({
                        range: [0.8, 1.5, 2],
                        output: [0, 1, 1]
                    }).to(x => `rgba(0, 0, 0, ${x})`)
                }}>수수료의</animated.p>
                <animated.p className={`${styles.sec07__font02} ${styles.notoBold} ${styles.marginDel}`} style={{
                    opacity: spring.x.to({
                        range: [0, 0.1, 0.3, 2.5, 2.6],
                        output: [0, 0, 1, 1, 0]
                    }).to(x => x),
                    translateY: spring.x.to({
                        range: [0, 0.1, 0.3, 1, 2.4, 2.6],
                        output: [10, 10, 0, 0, 0, -10]
                    }).to(x => `${x}vh`),
                    WebkitTextFillColor: spring.x.to({
                        range: [0.8, 1.5, 2],
                        output: [0, 1, 1]
                    }).to(x => `rgba(0, 0, 0, ${x})`)
                }}>3%가 쌓이는</animated.p>
            </div>
            <animated.svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" xmlSpace="preserve"
                          className={`${styles['section07-rotation']}`}
                          style={{
                              rotate: spring.x.to({
                                  range: [2, 2.4, 2.8, 3],
                                  output: [0, 0, 90, 90]
                              }).to(x => `${x}deg`),
                              scale: spring.x.to({
                                  range: [2, 2.4, 2.6, 2.8, 3],
                                  output: [1, 1, 1.5, 3.5, 10]
                              }).to(x => x),
                              translateY: spring.x.to({
                                  range: [2, 2.25, 3],
                                  output: [-7, -2, -2]
                              }).to(x => `${x}vh`),
                          }}
            >
                { rects.map((rect, index) => <animated.rect
                    key={index}
                    className={styles['section07-transition__item']}
                    x="33.867vw"
                    style={{
                        y: `${centerBoxY + ((index - 5) * boxWithGap)}vh`,
                        scale: spring.x.to({
                            range: rect.range,
                            output: [0.9, 0.9, 1, 1]
                        }).to(x => x),
                        fillOpacity: spring.x.to({
                            range: [2, 2.5, 2.8, 3],
                            output: [0, 0, 0.9, 1]
                        }).to(x => x),
                        opacity: spring.x.to({
                            range: rect.range,
                            output: rect.output,
                        }).to(x => x)
                    }}
                />)}
            </animated.svg>
        </animated.div>
    )
}